module.exports = __webpack_public_path__ + "img/agent-center-chat.6d9472ec.png";